const ReferrerType = () =>
  import(
    /* webpackChunkName: "base-info-club-referrer-type" */ '@/pages/base-info/club/referrer-type/index.vue'
  )
const CreateReferrerType = () =>
  import(
    /* webpackChunkName: "base-info-club-referrer-type" */ '@/pages/base-info/club/referrer-type/create.vue'
  )
const EditReferrerType = () =>
  import(
    /* webpackChunkName: "base-info-club-referrer-type" */ '@/pages/base-info/club/referrer-type/edit.vue'
  )

export default {
  path: 'referrer-type',
  meta: {
    label: 'referrerType',
    auth: 'referrerType'
  },
  component: {
    name: 'ReferrerType',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'BaseInfoReferrerTypeReport',
      path: '/',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: ReferrerType
    },
    {
      name: 'BaseInfoCreateReferrerType',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateReferrerType
    },
    {
      name: 'BaseInfoEditReferrerType',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditReferrerType,
      props: true
    }
  ]
}
